import Axios from '../../config/axios';
import { BehaviorSubject } from 'rxjs';

export const reloadCompany = new BehaviorSubject(false);
export const reloadLayout = new BehaviorSubject(false);